import { EnumOption } from "./enum-option"

export const ActiveStatus = {
    Active: 0,
    InActive: 1,
    MarkForDel: 2,
}

export const ActiveStatusList: EnumOption[] = [
    { value: ActiveStatus.Active, label: 'Active' },
    { value: ActiveStatus.InActive, label: 'InActive' },
    { value: ActiveStatus.MarkForDel, label: 'Mark for Del' },
]
